import NewAbsenceRequestContent from './new-absence-request-content'

export default NewAbsenceRequestContent
